import {Breadcrumbs, Divider, Link, Stack, Typography} from "@mui/material";
import {Link as RouterLink, Navigate, useNavigate, useParams} from "react-router-dom";
import * as React from "react";
import {appSession} from "../../../Broadtask";
import {sectionStack, subSectionPanel} from "../../../../AppStyles";

const StreamListenerViewer = () =>
{
    const navigate = useNavigate();
    const {networkUID, streamUID, listenerUID} = useParams();

    return <Stack spacing={1}>
        <Stack direction="row"
               sx={{ backgroundColor: '#1e1e1e'}}
               alignItems="center" justifyContent="space-between" padding={1}>
            <Breadcrumbs>
                <Link component={RouterLink} to={"/"} underline={"hover"}>Home</Link>
                <Link component={RouterLink} to={"/networks"} underline={"hover"}>Networks</Link>
                <Link component={RouterLink} to={"/networks/" + networkUID} underline={"hover"}>{networkUID}</Link>
                <Link component={RouterLink} to={"/networks/" + networkUID + "/streams"} underline={"hover"}>Data Streams</Link>
                <Link component={RouterLink} to={"/networks/" + networkUID + "/streams/" + streamUID} underline={"hover"}>{streamUID}</Link>
                <Typography>{listenerUID}</Typography>
            </Breadcrumbs>
        </Stack>

        {
            appSession.activeSession() === false ?
            <Navigate to="/login"/> :
            <Stack direction="column" justifyContent="flex-start" alignItems="stretch"
                   spacing={2} padding={0}>

                <Stack direction="column" spacing={1} padding={1} width="100%"
                       alignItems="flex-start" justifyContent="flex-start"
                       sx={sectionStack}>
                    <Stack direction="row" width="100%"
                           justifyContent="space-between"
                           padding={1} spacing={1}>
                        <Typography variant="h6">Data Stream Listener</Typography>
                    </Stack>
                    <Divider orientation="horizontal" variant="left" flexItem />
                    <Stack direction="column" spacing={1} width="100%" minHeight={100}
                           sx={subSectionPanel}>

                    </Stack>
                    <Divider orientation="horizontal" variant="left" flexItem />
                    <Stack direction="row" alignItems="center" justifyContent="space-between" paddingTop={1}>

                    </Stack>
                </Stack>

            </Stack>
        }

    </Stack>
};

export default StreamListenerViewer;
